import TooltipComponent from './TooltipComponent.vue';

const definirDistancia = (tooltip, position, { top, left, height, width }) => {
    tooltip.style.top = `${top}px`;
    tooltip.style.left = `${left}px`;

    switch (position) {
        case 'top':
            tooltip.style.marginTop = `-${tooltip.clientHeight + 5}px`;
            break;
        case 'right':
            tooltip.style.marginLeft = `${width + 5}px`;
            break;
        case 'bottom':
            tooltip.style.marginTop = `${height + 5}px`;
            break;
        case 'left':
            tooltip.style.marginLeft = `-${tooltip.clientWidth + 5}px`;
            break;
        default:
            break;
    }
};

export function TooltipDirective(el, binding) {
    if (el.classList.contains('tooltip-wrapper')) {
        return;
    }
    el.classList.add('tooltip-wrapper');
    const Tooltip = window.Vue.extend({
        render: (h) => h(TooltipComponent, { props: { label: binding.value?.label ?? binding.value, position: binding.value.position, minWidth: binding.value.minWidth } })
    });

    const component = new Tooltip().$mount();
    document.body.appendChild(component.$el);

    el.addEventListener('mouseenter', () => {
        const { top, left, height, width } = el.getBoundingClientRect();
        definirDistancia(component.$el, binding.value.position, { top, left, height, width });
        component.$el.style.opacity = 1;
    });

    el.addEventListener('mouseleave', () => {
        component.$el.style.opacity = 0;
    });
}
